import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import { Button, Card, CardContent, CardActions, Container, Typography } from '@material-ui/core';
import { useDispatch } from "react-redux";
import { clearSession } from "../actions/authentification";
import logo2 from './../images/ggcLogo2.png';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        alignContent: 'center',
        height: '90vh',
        width: '100%'
    },
    pageTitleDiv: {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        margin: 'auto',
        textAlign: 'center',
        padding: 30
    },
}));

export default function LogoutPage() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const [checkFirstTime, setCheckFirstTime] = useState(false);

    useEffect(() => {
        if (!checkFirstTime) {
            setCheckFirstTime(true);
            dispatch(clearSession());
        }
    }, []);

    return (
        <Container className={classes.container}>
            <Card className={classes.pageTitleDiv}>
                <CardContent>
                    <img style={{ minWidth: 180, maxWidth: 200 }} src={logo2} alt="PTT GGC" />
                    <Typography variant='h4' gutterBottom>
                            Logged Out
                    </Typography>
                    <Typography variant='body1'>
                            You have been successfully logged out!
                    </Typography>
                </CardContent>
                <CardActions style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                    <Button variant='contained' fullWidth color='default' onClick={() => history.push('/')}>
                        Home
                    </Button>
                </CardActions>
            </Card>
        </Container>
    )
}